const parseGroupContent = (content) => {
  // return content.childMarkdownRemark.html;
  return {};
};

const parseContactGroup = (group) => {
  return {
    title: group.title,
    content: parseGroupContent(group.content),
  };
};

export const ParseContactPage = (pageData) => {
  return {
    ruleLabel: pageData.eyebrow,
    heading: pageData.headline.headline,
    contactLines: pageData.content.map((group) => parseContactGroup(group)),
  };
};
